import { ITagSelect } from '../../features/disciplinas/components/lista-tag/lista-tag.types';
import { Curso } from '../../models/usuario.model';

export enum Modalidade {
  GRAD = 'GRAD',
  POS = 'POS',
  TEC = 'TEC',
}

export interface AppHeaderProps {
  isLead: boolean | null;
  isDisciplinasHome: boolean;
  curso: Curso | null;
  listaCurso: Curso[] | null;
  tagSelecionada: string;
  setTagSelecionada: React.Dispatch<React.SetStateAction<string>>;
  selecionarCurso: (item: Curso) => void;
  desktop: boolean;
  mobile: boolean;
  cursoSelecionadoLocal: string | null;
  tagPropsMapeadas: ITagSelect[];
  listaCursoFiltrada: () => Curso[];
}

export interface LeadContentProps {
  listaCurso: Curso[] | null;
  tagPropsMapeadas: ITagSelect[];
  tagSelecionada: string;
  setTagSelecionada: React.Dispatch<React.SetStateAction<string>>;
  listaCursoFiltrada: () => Curso[];
  selecionarCurso: (item: Curso) => void;
}

export interface AppHeaderLogoProps {
  mobile: boolean;
  isLead: boolean | null;
  parsedCurso: Curso | null;
  curso: Curso | null;
}
